/**
 * @alpha defines the primary color on the website.
 * it determines the overall look of a site
 *
 * @beta defines an ascent color on the website
 * it can be use to define less important actions and/or information for the end user.
 *
 * @gamma defines neutral color on the website
 * it determines the color of text, background, panels, form controls
 */

export const colors = {
  button: {
    intial: "#444444",
    hover: "#444444",
  },
  alpha: {
    alertLight: "#FC8B19",
    alertDark: "#E58F39",
    soothingLight: "#F5D4B3",
    soothingDark: "#EBD3BC",
    activeLight: "#C27121",
    activeDark: "#AD6C2A",
    passiveLight: "#C49C74",
    passiveDark: "#997D62",
    neutralLight: "#F6F0EA",
    neutralDark: "#FCFAF7",
  },
  gamma: {
    alertLight: "#474747",
    alertDark: "#0F0F0F",
    soothingLight: "#F2F4F5",
    soothingDark: "#DEE1E3",
    activeLight: "#C0C1C2",
    activeDark: "#8D8E8F",
    passiveLight: "#C0C3C4",
    passiveDark: "#5B5B5C",
    neutralLight: "#F8FAFB",
    neutralDark: "#1E2224",
  },
  brand: {
    alertLight: "#1919FA",
    alertDark: "#5D5DFA",
    soothingLight: "#B3B3F5",
    soothingDark: "#C3C3E3",
    activeLight: "#2121C2",
    activeDark: "#121242",
    passiveLight: "#7474C4",
    passiveDark: "#626299",
    neutralLight: "#F8F8FA",
    neutralDark: "#F0F0FC",
  },
}
